import {
  AlertTriangle,
  ArrowLeftRight,
  BarChart2,
  ClipboardList,
  FileText,
  MessageSquare,
  Radio,
  TrendingUp,
  Utensils,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { PropertyType } from '../types/api.types'

export interface NavItem {
  label: string
  path: string
  Icon: LucideIcon
}

export const OPERATIONS_NAV: NavItem[] = [
  { label: 'Live Ops', path: '/live-ops', Icon: Radio },
  { label: 'Incidents', path: '/incidents', Icon: AlertTriangle },
  { label: 'Analytics', path: '/analytics', Icon: BarChart2 },
  { label: 'Transcripts', path: '/transcripts', Icon: FileText },
  { label: 'Handover', path: '/handover', Icon: ArrowLeftRight },
  { label: 'SLA & Escalation', path: '/sla-escalation', Icon: TrendingUp },
]

export const RESTAURANT_NAV: NavItem[] = [
  { label: 'Conversations', path: '/conversations', Icon: MessageSquare },
  { label: 'Orders', path: '/orders', Icon: ClipboardList },
  { label: 'Menu', path: '/menu', Icon: Utensils },
]

// ponytail: HOTEL reuses the security/ops set until its own menu is specced
export const NAV_BY_PROPERTY_TYPE: Record<PropertyType, NavItem[]> = {
  SECURITY: OPERATIONS_NAV,
  HOTEL: OPERATIONS_NAV,
  RESTAURANT: RESTAURANT_NAV,
}

// Where a property's users land. Defined as the first item of its own nav so
// the landing page and the sidebar can never drift apart.
export function homePathFor(propertyType: PropertyType): string {
  return NAV_BY_PROPERTY_TYPE[propertyType][0].path
}

// Which verticals list this path in their nav. An empty result means the page
// is not owned by any vertical — /admin, for instance, which every property
// type has. Derived from the nav map on purpose: adding a sidebar item is what
// makes its route reachable, so the two cannot drift.
export function verticalsOwning(pathname: string): PropertyType[] {
  const types = Object.keys(NAV_BY_PROPERTY_TYPE) as PropertyType[]
  return types.filter((type) =>
    NAV_BY_PROPERTY_TYPE[type].some((item) => item.path === pathname),
  )
}
